<template>
  <!-- 对话框 -->
  <el-drawer :visible.sync="show" :with-header="false" :wrapperClosable="false" :before-close="closeDialog" size="80%"
             @opened="opened">

    <!-- 基本信息表单 -->
    <div class="form-box">

      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 100%; overflow-y: auto;">



          <div id="add-container" class="map"></div>

          <el-form-item label="商家名称:" label-width='120px'  style="position: relative;">
            <el-input v-model="submit_data.inspection_line_name" @input="onInput(submit_data.inspection_line_name)" :placeholder="submit_rules.inspection_line_name.placeholder"
                      style="width: 300px;">
            </el-input>

            <ul id="start-panel" v-if="start_panel_show">
              <li class="list" v-for="(item, index) in start_panel_innerHtml" :key="index"
                  @click="listClick(item.location.lng,item.location.lat,item.title)">

                <div style="padding-left: 20px;">
                  <p class='list-name'>

                    <span style="display: inline-block;">{{ item.title }}</span>
                  </p>
                  <p class='list-address'>{{ item.address }}</p>
                </div>

              </li>
            </ul>
          </el-form-item>

          <el-form-item label="商家电话:" label-width='120px'>
            <el-input v-model="submit_data.inspection_line_phone" :placeholder="submit_rules.inspection_line_phone.placeholder" maxlength='11'
                      style="width: 300px">
            </el-input>
          </el-form-item>


          <el-form-item label="详细地址:" label-width='120px'>
            <el-input v-model="submit_data.inspection_line_address" type="textarea" :placeholder="submit_rules.inspection_line_address.placeholder"
                      style="width: 80%;">
            </el-input>
          </el-form-item>





          <el-form-item label="备注:" label-width='120px'>
            <el-input v-model="submit_data.remarks" type="textarea" :placeholder="submit_rules.remarks.placeholder"
                      style="width: 80%;">
            </el-input>
          </el-form-item>


        </el-form>





      </template>



    </div>

    <!-- 对话框底部按钮 -->
    <div style="display: flex;justify-content: center;margin-top: 20px;">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>


  </el-drawer>
</template>

<script>
  var _this, map, marker;
  import {
    config
  } from '../../../utils/config'; // 配置
  export default {
    props: {
      'isShow': Boolean,
      'data':''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.submit_data.inspection_line_code = _this.data;






      },
    },
    data() {
      return {


        show: false,



        start_panel_show:false,
        start_panel_innerHtml: [],

        //当前城市
        currentCity:'',


        // 表单数据
        submit_data: {
          inspection_line_code:'',
          inspection_line_name: '',
          inspection_line_address: '',
          inspection_line_phone: '',
          remarks: '',
          lng: '',
          lat: '',
        },

        submit_rules: {
          inspection_line_name: {
            placeholder: '请输入商家名称',
            rules: {
              required: false,
              message: '地址名称需在50字之内',
              regulation: 'elt_str',
              rulesData: 50
            }
          },
          inspection_line_phone: {
            placeholder: '请输入商家电话',
            rules: {
              required: false,
              message: '商家电话错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          lng: {
            placeholder: '点击地图生成坐标点',
            rules: {
              required: false,
              message: '请点击地图生成坐标点',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          lat: {
            placeholder: '点击地图生成坐标点',
            rules: {
              required: false,
              message: '请点击地图生成坐标点',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          inspection_line_address: {
            placeholder: '请输入备注',
            rules: {
              required: false,
              message: '备注小于255字',
              regulation: 'elt_str',
              rulesData: 255
            }
          },

          remarks: {
            placeholder: '请输入备注',
            rules: {
              required: false,
              message: '备注小于255字',
              regulation: 'elt_str',
              rulesData: 255
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {

      onInput(val){


        if (val != '' && val != null) {
          _this.start_panel_show = true;

        if(_this.currentCity == '天津城区'){
          var options = {
            keyword: __this.submit_data.inspection_line_name,
            cityName: '天津'
          };
        }else{
          var options = {
            keyword: _this.submit_data.inspection_line_name,
            cityName: _this.currentCity
          };
        }
        var search = new TMap.service.Search();
        console.log(options);
        search.searchRegion(options).then(function(result) {

              console.log(result);

              _this.start_panel_innerHtml = [];

              for (let i = 0; i < result.data.length; i++) {

                // 添加列表内容
                if (result.data[i]) {
                  _this.start_panel_innerHtml.push(result.data[i]);

                }

              }


            })

        }else{
          _this.start_panel_show = false;
        }
      },





      // 地点列表点击触发
      listClick(lng, lat, text) {


        if (marker) {
           marker.setGeometries([])
        }
        marker = new TMap.MultiMarker({
            map: map,  //指定地图容器
            //样式定义
            styles: {
                //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                "myStyle": new TMap.MarkerStyle({
                    "width": 25,  // 点标记样式宽度（像素）
                    "height": 34, // 点标记样式高度（像素）
                    "src": require('@/assets/League.png'),  //图片路径
                    "offset": { x: -13, y: -30 }
                })
            },
            //点标记数据数组
            geometries: [{
                "id": "marker1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                "styleId": 'myStyle',  //指定样式id
                "position": new TMap.LatLng(lat, lng),  //点标记坐标位置
                "properties": {//自定义属性
                    "title": "marker1"
                }
            }
          ]

        });

        _this.submit_data.lng = lng;
        _this.submit_data.lat = lat;

        _this.submit_data.inspection_line_name = text

        _this.start_panel_show = false;


        // 缩放地图到合适的视野级别
        map.setCenter(new TMap.LatLng(lat, lng));

      },




      opened() {

        map = new TMap.Map("add-container", {
          resizeEnable: true,
          zoom: 11
        });



        var loginCityName = JSON.parse(localStorage.getItem('login')).city.name

        var x = loginCityName.indexOf('/');

        for (var i = 0; i < 1; i++) {
          x = loginCityName.indexOf('/', x + 1);
        }



        // 如果为市级
        if (x < 0) {

          // 截取城市名称 如:XXXX / 截取字段
          var city_name = loginCityName.slice(loginCityName.indexOf('/') + 2)



        } else {


          // 截取城市名称 如:XXXX / XXXX / 截取字段
          var city_name = loginCityName.slice(x + 2)


        }

        console.log(city_name);




        // 将城市赋值
        _this.currentCity = city_name;



        // 获取详情
        _this.$post(
                "/Inspectionline/getInspectionLineDetails", {
                  inspection_line_code: _this.data
                }
        ).then(res => {

          _this.submit_data.inspection_line_name  = res.data.inspection_line_name;
          _this.submit_data.lng = res.data.lng;
          _this.submit_data.lat = res.data.lat;
          _this.submit_data.inspection_line_address = res.data.inspection_line_address;
          _this.submit_data.inspection_line_phone = res.data.inspection_line_phone;
          _this.submit_data.remarks = res.data.remarks;

          marker = new TMap.MultiMarker({
            map: map,  //指定地图容器
            //样式定义
            styles: {
                //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                "myStyle": new TMap.MarkerStyle({
                    "width": 25,  // 点标记样式宽度（像素）
                    "height": 34, // 点标记样式高度（像素）
                    "src": require('@/assets/League.png'),  //图片路径
                    "offset": { x: -13, y: -30 }
                })
            },
            //点标记数据数组
            geometries: [{
                "id": "marker1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                "styleId": 'myStyle',  //指定样式id
                "position": new TMap.LatLng(res.data.lat, res.data.lng),  //点标记坐标位置
                "properties": {//自定义属性
                    "title": "marker1"
                }
            }
          ]

        });
        map.setCenter(new TMap.LatLng(res.data.lat, res.data.lng));


        })


      },







      // 关闭方法
      closeDialog() {
        _this.show = false;

        _this.submit_data = {
          inspection_line_name: '',
          inspection_line_address: '',
          inspection_line_phone: '',
          remarks: '',
          lng: '',
          lat: '',
        };



      },
      // 提交
      onSubmit() {

        _this.$post(
                "/Inspectionline/editInspectionLineSub",
                _this.submit_data,
                _this.submit_rules
        )
                .then(res => {

                  // 触发父组件自定义事件刷新表格
                  _this.$emit('onSubmit');
                  _this.closeDialog();
                  this.$message.success(res.msg);
                }).catch(res => {

        })

      },



    }
  };
</script>

<style scoped>
  .list {
    cursor: pointer;
    padding: 10px;
    transition: .5s;
  }
  #start-panel {
    position: absolute;
    background-color: white;
    overflow-y: auto;
    top: 35px;
    left: 0px;
    width: 280px;
    z-index: 9999;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
  }
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    height: calc(100vh - 100px);
    overflow-y: auto;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .map {
    height: 60%;
    width: 100%;
    margin-bottom: 20px;
  }
</style>
